import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSeller } from "../../hooks/useSeller";
import api from "../../services/api";
import { Loading } from "../Loading";
import { ModalInfo } from "../ModalInfo";
import "./index.css";
import ReactLoading from "react-loading";
import { usePluginspace } from "../../hooks/usePluginspace";
import { useAppConfig } from "../../hooks/useAppConfig";
import { ConfigType } from "../../contexts/AppConfigContext";
import { useCategory } from "../../hooks/useCategory";
import useAuth from "../../hooks/useAuth";
import CopyToClipboard from "react-copy-to-clipboard";
import Swal from "sweetalert2";
import { ShareIcon } from "../MenuIcons/ShareIcon";
import { CiViewList } from "react-icons/ci";
import { inherits } from "util";

type CategoriesType = {
  id: number;
  name: string;
  parent: string;
  code: string;
  level: number;
  displayed: boolean;
  open?: boolean;
};

type LeftMenuProps = {
  extraSpacingLeftMenu: boolean;
  cbSelected?: (selected: boolean) => void;
};

type PluginconfigType = {
  id: number;
  name: string;
  content: any;
  plugintemplateId: number;
  plugintypeId: number;
};

type TemplateType = {
  id: number;
  name: string;
  image: string | null;
  parameters: string;
  plugintypeId: number;
  pluginconfig: PluginconfigType;
  typeIntegration: string;
  able: boolean | null;
};

export function LeftMenu({
  extraSpacingLeftMenu = false,
  cbSelected,
}: LeftMenuProps) {
  const { pluginspace_id } = useParams();
  const navigate = useNavigate();
  const { getToken, getThisPluginspace } = usePluginspace();
  const { pluginspace } = usePluginspace();
  const { getCategoriesAll } = useCategory();

  const { logout } = useAuth();
  const [categories, setCategories] = useState<Array<CategoriesType>>([]);
  const [loading, setLoading] = useState(true);

  const [isOpenCategories, setIsOpenCategories] = useState(false);
  const [openInfo, setOpenInfo] = useState(false);
  const [loadingCategories, setLoadingCategories] = useState(true);
  const [loadingCart, setLoadingCart] = useState(true);

  const { getTokenSeller, sellerUser } = useSeller();
  const [emailSeller, setEmailSeller] = useState("");
  const [nameSeller, setNameSeller] = useState("");
  const [isSeller, setIsSeller] = useState<boolean>(false);

  const { getAppConfig, getSellerAppConfig } = useAppConfig();
  const [config, setConfig] = useState<ConfigType | void>();
  const [isFood, setIsFood] = useState<boolean>(false)

  const { pathname } = useLocation();
  const [text, setText] = useState<string>(
    `${window.location.host}/${pathname.split("/")[1]}`
  );
  const [hasIAPlugin, setHasIAPlugin] = useState(false);

  useEffect(() => {
    getAll();

    const tk = getTokenSeller();
    if (tk) {
      setEmailSeller(tk.email);
      setNameSeller(tk.name);
    }
  }, []);

  const verifyPluginsIA = async () => {
    try {
      const hasIALocal = localStorage.getItem(window.btoa("hasIA"));
      if (hasIALocal && window.atob(hasIALocal)) {
        const iaItem: any = JSON.parse(window.atob(hasIALocal));
        if (iaItem.pluginspace === pluginspace.id && iaItem.hasIA) return true;
      }
      const templateRes = await api.get("api/plugintemplate/ia", {
        headers: {
          Authorization: `Bearer ${await getToken()} `,
        },
      });
      let hasPlugin = false;
      if (templateRes && templateRes.data && templateRes.data.data) {
        templateRes.data.data.forEach((template: TemplateType) => {
          if (template.pluginconfig) {
            if (
              template.pluginconfig.content &&
              template.pluginconfig.content.able &&
              template.pluginconfig.content.able !== "0"
            ) {
              localStorage.setItem(
                window.btoa("hasIA"),
                window.btoa(
                  JSON.stringify({ pluginspace: pluginspace.id, hasIA: true })
                )
              );
              hasPlugin = true;
            }
          }
        });
      }
      return hasPlugin;
    } catch (e) {
      console.log(e);
      return false;
    }
  };

  async function getAll() {
    const tk = await getTokenSeller();
    const config = tk ? await getSellerAppConfig() : await getAppConfig();

    setIsFood(pluginspace && pluginspace.type === 'food')

    getCategoriesToOrder(config);
    getConfigs(config);
    setHasIAPlugin(await verifyPluginsIA());
  }

  async function getConfigs(conf: ConfigType | void) {
    setLoadingCart(true);
    setConfig(conf);
    setLoadingCart(false);
  }

  function getLevel(
    categories: CategoriesType[],
    thisCategory: CategoriesType,
    level: number
  ): number {
    if (thisCategory.parent && thisCategory.parent.length > 0) {
      level++;
      const fatherCategory = categories.find(
        (category) => thisCategory.parent === category.code
      );
      if (fatherCategory) {
        return getLevel(categories, fatherCategory, level);
      } else {
        return level;
      }
    } else {
      return level;
    }
  }

  function haveChildren(
    categories: CategoriesType[],
    thisCategory: CategoriesType
  ): boolean {
    const children = categories.filter(
      (category) => thisCategory.code === category.parent
    );
    return children.length > 0 ? true : false;
  }

  async function getCategoriesToOrder(conf: ConfigType | void) {
    let showOutStock =
      conf && conf.content && conf.content.pdv && conf.content.pdv.showOutStock
        ? conf.content.pdv.showOutStock
        : false;
    let orderCategory =
      conf && conf.content && conf.content.orderCategory
        ? conf.content.orderCategory
        : "";
    const categoriesResponse: CategoriesType[] = (
      await getCategoriesAll(showOutStock, orderCategory)
    ).map((category) => ({
      id: category.id,
      name: category.name,
      parent: category.parent,
      code: category.code,
      level: 0,
      displayed: false,
      open: false,
    }));

    const categoriesAjust = categoriesResponse.map(
      (category: CategoriesType) => {
        const level = getLevel(categoriesResponse, category, 1);
        const haveChildrens = haveChildren(categoriesResponse, category);
        if (haveChildrens) {
          return {
            id: category.id,
            name: category.name,
            level: level,
            code: category.code,
            parent: category.parent,
            displayed: false,
            open: false,
          };
        } else {
          return {
            id: category.id,
            name: category.name,
            level: level,
            code: category.code,
            parent: category.parent,
            displayed: false,
          };
        }
      }
    );
    setCategories(categoriesAjust);
    setLoadingCategories(false);
  }

  function openCategories(parent: string | null) {
    if (parent === "" || parent === null) {
      setIsOpenCategories(!isOpenCategories);
    }
    const newCategories = categories.map((cat) => {
      if (cat.parent === parent) {
        cat.displayed = !cat.displayed;
      }
      if (cat.code === parent) {
        cat.open = !cat.open;
      }
      return cat;
    });
    setCategories(organizeCategories(newCategories));
  }

  function organizeCategories(categories: CategoriesType[]) {
    let organizedCategories: CategoriesType[] = [];
    let organizedCategoriesId: number[] = [];
    categories.map((category) => {
      if (
        !organizedCategoriesId.includes(category.id) &&
        category.parent === null
      ) {
        organizedCategories.push(category);
        organizedCategoriesId.push(category.id);
        categories.map((childCategory) => {
          if (
            !organizedCategoriesId.includes(childCategory.id) &&
            childCategory.parent === category.code
          ) {
            organizedCategories.push(childCategory);
            organizedCategoriesId.push(childCategory.id);
          }
        });
      }
    });
    return organizedCategories;
  }

  async function defineShareLink() {
    const tk = getTokenSeller();

    if (tk) {
      setIsSeller(true);
      const cpfBase64 = window.btoa(tk.identifier);
      let text = ``;
      const ps = await getThisPluginspace();
      if (ps) {
        text = text.concat(
          `${ps.name}\nEstamos te esperando, corra na nossa loja digital e faça suas compras!\n`
        );
      }
      let url = `\n${window.location.host}/${pathname.split("/")[1]
        }/category?vendor=${cpfBase64}\n`;
      text = text.concat(url);
      if (sellerUser && sellerUser.numberPhone) {
        text = text.concat(
          `\nPara mais informações, pode chamar no seguinte número: ${sellerUser.numberPhone}, meu nome é ${sellerUser.name}\ne estarei a disposição para qualquer dúvida`
        );
      }

      setText(text);
    }
  }

  useEffect(() => {
    defineShareLink();
  }, []);

  const getLandmark = () => {
    const landmark = localStorage.getItem("landmark_synkar");
    if (landmark) {
      const landmarkItem = JSON.parse(window.atob(landmark));
      return landmarkItem.interval;
    } else {
      return null;
    }
  };

  const getCounterNumber = () => {
    return localStorage.getItem("counter_number");
  };

  const getCardNumber = () => {
    return localStorage.getItem("card_number");
  };

  const getTableNumber = () => {
    return localStorage.getItem("table_number");
  };

  const getInternalNumber = () => {
    return localStorage.getItem("internal_number");
  };

  const navigateToCart = () => {
    try {
      // ✅ 1. Verificar comanda (localStorage é a fonte correta)
      const cardNumber = localStorage.getItem("card_number");

      // ✅ 2. Verificar se é template food/retail SEM mesa/comanda/balcão
      const hasTableNumber = getTableNumber();
      const hasCardNumber = getCardNumber(); // localStorage fallback
      const hasLandmark = getLandmark();
      const hasCounterNumber = getCounterNumber();
      const hasInternalNumber = getInternalNumber();

      const isFood = pluginspace?.type === "food";
      const hasAnyFoodMode = hasTableNumber || hasCardNumber || hasLandmark || hasCounterNumber || hasInternalNumber;
      const hasAppLogin = pluginspace?.appLogin;


      if (hasAnyFoodMode || cardNumber) {
        navigate(`/${pluginspace_id}/cart-card`);
        return;
      }

      // ✅ 3. Se for retail/ecommerce sem modo food e sem vendedor -> novo carrinho
      if (pluginspace && !isFood && !hasAnyFoodMode && !isSeller && hasAppLogin) {
        navigate(`/${pluginspace_id}/new-cart`);
        return;
      }

      // ✅ 4. Todos os outros casos -> carrinho padrão
      // (Vendedor, Food, ou sem login)
      navigate(`/${pluginspace_id}/cart`);

    } catch (error) {
      console.error("Erro ao navegar para carrinho:", error);
      // ✅ 5. Fallback em caso de erro
      try {
        navigate(`/${pluginspace_id}/cart`);
      } catch (fallbackError) {
        console.error("Erro crítico na navegação:", fallbackError);
        // Último recurso: reload com hash
        window.location.href = `/${pluginspace_id}/cart`;
      }
    }
  };

  return (
    <>
      <div
        className="left-menu"
        style={{
          backgroundColor: config?.webappcolor.backgroundmenu
            ? config.webappcolor.backgroundmenu
            : "#FFF",
          color: config?.webappcolor.fontmenu
            ? config.webappcolor.fontmenu
            : "#636363",
          fill: config?.webappcolor.fontmenu || "#37393D",
        }}
      >
        <ul className="left-menu-items">
          {sellerUser && (
            <div className="seller-info">
              {sellerUser.image &&
                sellerUser.image != "default/default-user.jpg" && (
                  <div className="seller-info-img">
                    <img src={sellerUser.image} alt="" />
                  </div>
                )}

              <div className="seller-info-data">
                <span className="name"> {sellerUser.name}</span>
                <span className="email"> {sellerUser.email}</span>
              </div>
            </div>
          )}
          {localStorage.getItem("seller-tk") ? (
            <>
              <li className="item">
                <div
                  className="icons"
                  onClick={() => navigate(`/${pluginspace_id}/seller-profile`)}
                >
                  <div className="item-text">
                    <svg
                      width="13"
                      height="15"
                      viewBox="0 0 13 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.3125 4.25C8.3125 3.48438 7.875 2.77344 7.21875 2.36328C6.53516 1.98047 5.6875 1.98047 5.03125 2.36328C4.34766 2.77344 3.9375 3.48438 3.9375 4.25C3.9375 5.04297 4.34766 5.75391 5.03125 6.16406C5.6875 6.54688 6.53516 6.54688 7.21875 6.16406C7.875 5.75391 8.3125 5.04297 8.3125 4.25ZM2.625 4.25C2.625 3.01953 3.28125 1.87109 4.375 1.24219C5.44141 0.613281 6.78125 0.613281 7.875 1.24219C8.94141 1.87109 9.625 3.01953 9.625 4.25C9.625 5.50781 8.94141 6.65625 7.875 7.28516C6.78125 7.91406 5.44141 7.91406 4.375 7.28516C3.28125 6.65625 2.625 5.50781 2.625 4.25ZM1.33984 13.4375H10.8828C10.6367 11.7148 9.16016 10.375 7.35547 10.375H4.86719C3.0625 10.375 1.58594 11.7148 1.33984 13.4375ZM0 13.957C0 11.25 2.16016 9.0625 4.86719 9.0625H7.35547C10.0625 9.0625 12.25 11.25 12.25 13.957C12.25 14.3945 11.8672 14.75 11.4297 14.75H0.792969C0.355469 14.75 0 14.3945 0 13.957Z"
                        fill={config?.webappcolor.fontmenu || "#37393D"}
                      />
                    </svg>
                    <p>Meu Perfil</p>
                  </div>
                </div>
              </li>
              <li className="item">
                <CopyToClipboard
                  text={text}
                  onCopy={() =>
                    Swal.fire({
                      icon: "success",
                      title: "Link copiado!",
                      text: "Link do vendedor foi salvo em sua área de transferência.",
                    })
                  }
                >
                  <div className="icons">
                    <div className="item-text">
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.25 3.25C12.25 4.69922 11.0742 5.875 9.625 5.875C8.83203 5.875 8.12109 5.54688 7.62891 4.97266L5.16797 6.20312C5.22266 6.39453 5.22266 6.58594 5.22266 6.75C5.22266 6.94141 5.22266 7.13281 5.16797 7.32422L7.62891 8.52734C8.12109 7.98047 8.83203 7.625 9.625 7.625C11.0742 7.625 12.25 8.80078 12.25 10.25C12.25 11.6992 11.0742 12.875 9.625 12.875C8.14844 12.875 7 11.6992 7 10.25C7 10.0859 7 9.89453 7.05469 9.70312L4.59375 8.47266C4.10156 9.04688 3.39062 9.375 2.625 9.375C1.14844 9.375 0 8.19922 0 6.75C0 5.30078 1.14844 4.125 2.625 4.125C3.39062 4.125 4.10156 4.48047 4.59375 5.02734L7.05469 3.82422C7 3.63281 7 3.44141 7 3.25C7 1.80078 8.14844 0.625 9.625 0.625C11.0742 0.625 12.25 1.80078 12.25 3.25ZM2.59766 8.0625C3.33594 8.0625 3.91016 7.48828 3.91016 6.75C3.91016 6.03906 3.33594 5.4375 2.59766 5.4375C1.88672 5.4375 1.28516 6.03906 1.28516 6.75C1.28516 7.48828 1.88672 8.0625 2.59766 8.0625ZM9.625 1.9375C8.88672 1.9375 8.3125 2.53906 8.3125 3.25C8.3125 3.98828 8.88672 4.5625 9.625 4.5625C10.3359 4.5625 10.9375 3.98828 10.9375 3.25C10.9375 2.53906 10.3359 1.9375 9.625 1.9375ZM9.625 11.5625C10.3359 11.5625 10.9375 10.9883 10.9375 10.25C10.9375 9.53906 10.3359 8.9375 9.625 8.9375C8.88672 8.9375 8.3125 9.53906 8.3125 10.25C8.3125 10.9883 8.88672 11.5625 9.625 11.5625Z"
                          fill={config?.webappcolor.fontmenu || "#37393D"}
                        />
                      </svg>
                      <p>Compartilhar</p>
                    </div>
                  </div>
                </CopyToClipboard>
              </li>
              <li className="item">
                <div
                  className="icons"
                  onClick={() => navigate(`/${pluginspace_id}/sellerOrder`)}
                >
                  <div className="item-text">
                    <svg
                      width="16"
                      height="15"
                      viewBox="0 0 16 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.65625 0.75H1.88672C2.48828 0.75 3.03516 1.10547 3.28125 1.625H14.5195C15.2305 1.625 15.75 2.30859 15.5586 3.01953L14.4375 7.17578C14.2188 8.05078 13.4258 8.625 12.5508 8.625H4.64844L4.8125 9.41797C4.86719 9.71875 5.14062 9.9375 5.44141 9.9375H13.3438C13.6992 9.9375 14 10.2383 14 10.5938C14 10.9766 13.6992 11.25 13.3438 11.25H5.44141C4.51172 11.25 3.69141 10.5938 3.52734 9.66406L2.10547 2.25391C2.07812 2.14453 1.99609 2.0625 1.88672 2.0625H0.65625C0.273438 2.0625 0 1.78906 0 1.40625C0 1.05078 0.273438 0.75 0.65625 0.75ZM3.58203 2.9375L4.40234 7.3125H12.5508C12.8516 7.3125 13.0977 7.12109 13.1797 6.84766L14.2188 2.9375H3.58203ZM4.8125 14.75C4.32031 14.75 3.91016 14.5039 3.66406 14.0938C3.41797 13.7109 3.41797 13.1914 3.66406 12.7812C3.91016 12.3984 4.32031 12.125 4.8125 12.125C5.27734 12.125 5.6875 12.3984 5.93359 12.7812C6.17969 13.1914 6.17969 13.7109 5.93359 14.0938C5.6875 14.5039 5.27734 14.75 4.8125 14.75ZM14 13.4375C14 13.9297 13.7266 14.3398 13.3438 14.5859C12.9336 14.832 12.4141 14.832 12.0312 14.5859C11.6211 14.3398 11.375 13.9297 11.375 13.4375C11.375 12.9727 11.6211 12.5625 12.0312 12.3164C12.4141 12.0703 12.9336 12.0703 13.3438 12.3164C13.7266 12.5625 14 12.9727 14 13.4375Z"
                        fill={config?.webappcolor.fontmenu || "#37393D"}
                      />
                    </svg>
                    <p>Carrinhos enviados</p>
                  </div>
                </div>
              </li>
              <li className="item">
                <div
                  className="icons"
                  onClick={() => navigate(`/${pluginspace_id}/sellerCatalogs`)}
                >
                  <div className="item-text">
                    <CiViewList
                      color={config?.webappcolor.fontmenu || "#37393D"}
                    />
                    <p>Meus Catálogos</p>
                  </div>
                </div>
              </li>
              <li className="item">
                <div
                  className="icons"
                  onClick={() =>
                    navigate(`/${pluginspace_id}/seller-dashboard`)
                  }
                >
                  <div className="item-text">
                    <svg
                      width="13"
                      height="13"
                      viewBox="0 0 13 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.5625 1.9375H5.6875V11.5625H6.5625V1.9375ZM5.6875 0.625H6.5625C7.27344 0.625 7.875 1.22656 7.875 1.9375V11.5625C7.875 12.3008 7.27344 12.875 6.5625 12.875H5.6875C4.94922 12.875 4.375 12.3008 4.375 11.5625V1.9375C4.375 1.22656 4.94922 0.625 5.6875 0.625ZM2.1875 7.1875H1.3125V11.5625H2.1875V7.1875ZM1.3125 5.875H2.1875C2.89844 5.875 3.5 6.47656 3.5 7.1875V11.5625C3.5 12.3008 2.89844 12.875 2.1875 12.875H1.3125C0.574219 12.875 0 12.3008 0 11.5625V7.1875C0 6.47656 0.574219 5.875 1.3125 5.875ZM10.0625 3.6875V11.5625H10.9375V3.6875H10.0625ZM8.75 3.6875C8.75 2.97656 9.32422 2.375 10.0625 2.375H10.9375C11.6484 2.375 12.25 2.97656 12.25 3.6875V11.5625C12.25 12.3008 11.6484 12.875 10.9375 12.875H10.0625C9.32422 12.875 8.75 12.3008 8.75 11.5625V3.6875Z"
                        fill={config?.webappcolor.fontmenu || "#37393D"}
                      />
                    </svg>
                    <p>Resultados</p>
                  </div>
                </div>
              </li>
              <li
                className="item"
                onClick={() => navigate(`/${pluginspace_id}/store-info`)}
              >
                <div className="item-text">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 24.9952C19.624 24.9952 25 19.624 25 12.9952C25 6.3664 19.624 1 13 1C6.376 1 1 6.3712 1 13C1 19.6288 6.3712 25 13 25V24.9952ZM11.1232 16.7488H12.2464V13.7488H11.1232C10.4992 13.7488 10 13.2496 10 12.6256C10 12.0016 10.4992 11.5024 11.1232 11.5024H13.3744C13.9984 11.5024 14.4976 12.0016 14.4976 12.6256V16.7488H14.872C15.496 16.7488 15.9952 17.248 15.9952 17.872C15.9952 18.496 15.496 18.9952 14.872 18.9952H11.1232C10.4992 18.9952 10 18.496 10 17.872C10 17.248 10.4992 16.7488 11.1232 16.7488ZM13 7C13.8304 7 14.4976 7.672 14.4976 8.4976C14.4976 9.3232 13.8256 9.9952 13 9.9952C12.1744 9.9952 11.5024 9.3232 11.5024 8.4976C11.5024 7.672 12.1744 7 13 7Z"
                      stroke={config?.webappcolor.fontmenu || "#37393D"}
                      stroke-miterlimit="10"
                    />
                  </svg>

                  <p>Informações da loja</p>
                </div>
              </li>
              <li
                className="item"
                onClick={() => {
                  openCategories("");
                  openCategories(null);
                }}
              >
                <div className="item-text">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 26 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.798 8.31537C9.42978 8.31537 6.06152 8.31537 2.69326 8.31537C2.48184 8.31537 2.27042 8.32496 2.06381 8.30576C1.01153 8.20975 0.507006 7.35049 1.06918 6.46721C2.10705 4.83025 3.19297 3.22208 4.31252 1.64273C4.50471 1.3691 4.98041 1.1531 5.32156 1.1531C10.3283 1.1243 15.335 1.11948 20.337 1.16268C20.7214 1.16268 21.2259 1.48433 21.4613 1.81076C22.4992 3.2509 23.4554 4.74864 24.4452 6.22238C24.7623 6.69282 25.0458 7.24488 24.623 7.69612C24.3155 8.02255 23.7629 8.28657 23.3161 8.29137C19.8084 8.33938 16.3008 8.32018 12.7884 8.32018L12.798 8.31537Z"
                      stroke={config?.webappcolor.fontmenu || "#37393D"}
                      stroke-miterlimit="10"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.8555 9.58789H15.1427C15.1571 9.81831 15.1859 10.0391 15.1859 10.2647C15.1859 13.073 15.1907 15.8765 15.1859 18.6847C15.1859 19.976 14.8207 20.3313 13.5042 20.3313C10.65 20.3313 7.7911 20.3313 4.93697 20.3313C3.61561 20.3313 3.2168 19.9377 3.2168 18.6175C3.2168 15.6269 3.2168 12.6362 3.2168 9.59747H5.59044V15.5212H12.8507V9.58789H12.8555Z"
                      stroke={config?.webappcolor.fontmenu || "#37393D"}
                      stroke-miterlimit="10"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20.1445 9.56836H22.3932C22.4076 9.78438 22.4364 9.98602 22.4364 10.1876C22.4364 13.2023 22.4508 16.2218 22.422 19.2365C22.422 19.5773 22.2106 20.1726 22.0232 20.2062C21.4562 20.3022 20.846 20.2062 20.2646 20.1198C20.1733 20.1054 20.0724 19.7597 20.0676 19.5677C20.058 16.2938 20.0676 13.0199 20.0724 9.74597C20.0724 9.70277 20.106 9.66437 20.1445 9.56836Z"
                      stroke={config?.webappcolor.fontmenu || "#37393D"}
                      stroke-miterlimit="10"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <p>Categorias</p>
                </div>
                {categories.length > 0 && !loadingCategories ? (
                  <svg
                    style={
                      isOpenCategories
                        ? { transform: "rotate(90deg)" }
                        : { transform: "rotate(0deg)" }
                    }
                    width="13"
                    height="21"
                    viewBox="0 0 13 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 2L10 10.5L2 19"
                      stroke="#636363"
                      strokeWidth={3}
                      strokeLinecap="round"
                    />
                  </svg>
                ) : (
                  <ReactLoading
                    type="spinningBubbles"
                    color="#636363"
                    height={21}
                    width={21}
                  />
                )}
              </li>
              <li className="subcategories-items">
                <ul>
                  {categories.map((cat) => {
                    if (cat.displayed) {
                      const haveMore = !!categories.find(
                        (sub) => sub.parent === cat.code
                      );
                      const alphaColor = (0.1 * cat.level)
                        .toFixed(1)
                        .toString();
                      return (
                        <li
                          key={cat.id}
                          className="item"
                          style={{
                            paddingLeft: 20 * cat.level + 15,
                            backgroundColor: `rgba(0, 0, 0, ${alphaColor})`,
                          }}
                          onClick={() => haveMore && openCategories(cat.code)}
                        >
                          <p
                            onClick={() => {
                              cbSelected && cbSelected(true);
                              haveMore
                                ? navigate(
                                  `/ ${pluginspace_id} /subcategory/${cat.id} `
                                )
                                : config &&
                                  (config.template === "food" ||
                                    config.template === "retail")
                                  ? config.content &&
                                    config.content.pdv &&
                                    config.content.pdv.showLayout === "l2"
                                    ? navigate(
                                      `/${pluginspace_id}/products-new?subcategory=${cat.id}`
                                    )
                                    : navigate(
                                      `/${pluginspace_id}/products?subcategory=${cat.id}`
                                    )
                                  : navigate(`/${pluginspace_id}/pdv/${cat.id}`);
                            }}
                          >
                            {cat.name}
                          </p>
                          {haveMore && (
                            <svg
                              style={
                                cat?.open
                                  ? {
                                    transform: "rotate(90deg)",
                                  }
                                  : {
                                    transform: "rotate(0deg)",
                                  }
                              }
                              width="13"
                              height="21"
                              viewBox="0 0 13 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M2 2L10 10.5L2 19"
                                stroke="#636363"
                                strokeWidth={3}
                                strokeLinecap="round"
                              />
                            </svg>
                          )}
                        </li>
                      );
                    }
                    return <div key={cat.id} />;
                  })}
                </ul>
              </li>
              <li
                className="item"
                onClick={() => navigate(`/${pluginspace_id}/seller`)}
              >
                <div className="item-text">
                  <svg
                    width="14"
                    height="13"
                    viewBox="0 0 14 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.625 3.76953V5.21875C9.625 5.60156 9.32422 5.875 8.96875 5.875H5.6875V7.625H8.96875C9.32422 7.625 9.625 7.92578 9.625 8.28125V9.75781L12.6328 6.75L9.625 3.76953ZM14 6.75C14 7.07812 13.8633 7.37891 13.6445 7.59766L10.4727 10.7695C10.2266 11.0156 9.89844 11.125 9.57031 11.125C8.85938 11.125 8.3125 10.5781 8.3125 9.86719V8.9375H5.6875C4.94922 8.9375 4.375 8.36328 4.375 7.625V5.875C4.375 5.16406 4.94922 4.5625 5.6875 4.5625H8.3125V3.66016C8.3125 2.94922 8.85938 2.375 9.57031 2.375C9.89844 2.375 10.2266 2.51172 10.4727 2.75781L13.6445 5.92969C13.8633 6.14844 14 6.44922 14 6.75ZM4.59375 1.9375H2.40625C1.77734 1.9375 1.3125 2.42969 1.3125 3.03125V10.4688C1.3125 11.0977 1.77734 11.5625 2.40625 11.5625H4.59375C4.94922 11.5625 5.25 11.8633 5.25 12.2188C5.25 12.6016 4.94922 12.875 4.59375 12.875H2.40625C1.06641 12.875 0 11.8086 0 10.4688V3.03125C0 1.71875 1.06641 0.625 2.40625 0.625H4.59375C4.94922 0.625 5.25 0.925781 5.25 1.28125C5.25 1.66406 4.94922 1.9375 4.59375 1.9375Z"
                      fill={config?.webappcolor.fontmenu || "#37393D"}
                    />
                  </svg>

                  <p>Sair</p>
                </div>
              </li>
            </>
          ) : (
            <>
              <li
                className="item"
                onClick={() => {
                  openCategories("");
                  openCategories(null);
                }}
              >
                <div className="item-text">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 26 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.798 8.31537C9.42978 8.31537 6.06152 8.31537 2.69326 8.31537C2.48184 8.31537 2.27042 8.32496 2.06381 8.30576C1.01153 8.20975 0.507006 7.35049 1.06918 6.46721C2.10705 4.83025 3.19297 3.22208 4.31252 1.64273C4.50471 1.3691 4.98041 1.1531 5.32156 1.1531C10.3283 1.1243 15.335 1.11948 20.337 1.16268C20.7214 1.16268 21.2259 1.48433 21.4613 1.81076C22.4992 3.2509 23.4554 4.74864 24.4452 6.22238C24.7623 6.69282 25.0458 7.24488 24.623 7.69612C24.3155 8.02255 23.7629 8.28657 23.3161 8.29137C19.8084 8.33938 16.3008 8.32018 12.7884 8.32018L12.798 8.31537Z"
                      stroke={config?.webappcolor.fontmenu || "#37393D"}
                      stroke-miterlimit="10"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.8555 9.58789H15.1427C15.1571 9.81831 15.1859 10.0391 15.1859 10.2647C15.1859 13.073 15.1907 15.8765 15.1859 18.6847C15.1859 19.976 14.8207 20.3313 13.5042 20.3313C10.65 20.3313 7.7911 20.3313 4.93697 20.3313C3.61561 20.3313 3.2168 19.9377 3.2168 18.6175C3.2168 15.6269 3.2168 12.6362 3.2168 9.59747H5.59044V15.5212H12.8507V9.58789H12.8555Z"
                      stroke={config?.webappcolor.fontmenu || "#37393D"}
                      stroke-miterlimit="10"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20.1445 9.56836H22.3932C22.4076 9.78438 22.4364 9.98602 22.4364 10.1876C22.4364 13.2023 22.4508 16.2218 22.422 19.2365C22.422 19.5773 22.2106 20.1726 22.0232 20.2062C21.4562 20.3022 20.846 20.2062 20.2646 20.1198C20.1733 20.1054 20.0724 19.7597 20.0676 19.5677C20.058 16.2938 20.0676 13.0199 20.0724 9.74597C20.0724 9.70277 20.106 9.66437 20.1445 9.56836Z"
                      stroke={config?.webappcolor.fontmenu || "#37393D"}
                      stroke-miterlimit="10"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <p>Categorias</p>
                </div>
                {categories.length > 0 && !loadingCategories ? (
                  <svg
                    style={
                      isOpenCategories
                        ? { transform: "rotate(90deg)" }
                        : { transform: "rotate(0deg)" }
                    }
                    width="13"
                    height="21"
                    viewBox="0 0 13 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 2L10 10.5L2 19"
                      stroke={config?.webappcolor.fontmenu || "#37393D"}
                      strokeWidth={3}
                      strokeLinecap="round"
                    />
                  </svg>
                ) : (
                  <ReactLoading
                    type="spinningBubbles"
                    color="#636363"
                    height={21}
                    width={21}
                  />
                )}
              </li>
              <li className="subcategories-items">
                <ul>
                  {categories.map((cat) => {
                    if (cat.displayed) {
                      const haveMore = !!categories.find(
                        (sub) => sub.parent === cat.code
                      );
                      const alphaColor = (0.1 * cat.level)
                        .toFixed(1)
                        .toString();
                      return (
                        <li
                          key={cat.id}
                          className="item"
                          style={{
                            paddingLeft: 20 * cat.level + 15,
                            backgroundColor: `rgba(0, 0, 0, ${alphaColor})`,
                          }}
                          onClick={() => haveMore && openCategories(cat.code)}
                        >
                          <p
                            onClick={() => {
                              cbSelected && cbSelected(true);
                              haveMore
                                ? navigate(
                                  `/ ${pluginspace_id} /subcategory/${cat.id} `
                                )
                                : config &&
                                  (config.template === "food" ||
                                    config.template === "retail")
                                  ? config.content &&
                                    config.content.pdv &&
                                    config.content.pdv.showLayout === "l2"
                                    ? navigate(
                                      `/${pluginspace_id}/products-new?subcategory=${cat.id}`
                                    )
                                    : navigate(
                                      `/${pluginspace_id}/products?subcategory=${cat.id}`
                                    )
                                  : navigate(`/${pluginspace_id}/pdv/${cat.id}`);
                            }}
                          >
                            {cat.name}
                          </p>
                          {haveMore && (
                            <svg
                              style={
                                cat?.open
                                  ? {
                                    transform: "rotate(90deg)",
                                  }
                                  : {
                                    transform: "rotate(0deg)",
                                  }
                              }
                              width="13"
                              height="21"
                              viewBox="0 0 13 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M2 2L10 10.5L2 19"
                                stroke={
                                  config?.webappcolor.fontmenu || "#37393D"
                                }
                                strokeWidth={3}
                                strokeLinecap="round"
                              />
                            </svg>
                          )}
                        </li>
                      );
                    }
                    return <div key={cat.id} />;
                  })}
                </ul>
              </li>
              <li
                className="item"
                onClick={() => navigate(`/${pluginspace_id}/store-info`)}
              >
                <div className="item-text">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 24.9952C19.624 24.9952 25 19.624 25 12.9952C25 6.3664 19.624 1 13 1C6.376 1 1 6.3712 1 13C1 19.6288 6.3712 25 13 25V24.9952ZM11.1232 16.7488H12.2464V13.7488H11.1232C10.4992 13.7488 10 13.2496 10 12.6256C10 12.0016 10.4992 11.5024 11.1232 11.5024H13.3744C13.9984 11.5024 14.4976 12.0016 14.4976 12.6256V16.7488H14.872C15.496 16.7488 15.9952 17.248 15.9952 17.872C15.9952 18.496 15.496 18.9952 14.872 18.9952H11.1232C10.4992 18.9952 10 18.496 10 17.872C10 17.248 10.4992 16.7488 11.1232 16.7488ZM13 7C13.8304 7 14.4976 7.672 14.4976 8.4976C14.4976 9.3232 13.8256 9.9952 13 9.9952C12.1744 9.9952 11.5024 9.3232 11.5024 8.4976C11.5024 7.672 12.1744 7 13 7Z"
                      stroke={config?.webappcolor.fontmenu || "#37393D"}
                      stroke-miterlimit="10"
                    />
                  </svg>

                  <p>Informações da loja</p>
                </div>
              </li>
              {loadingCart ? (
                <li className="item">
                  <ReactLoading
                    type="spinningBubbles"
                    color={config?.webappcolor.fontmenu || "#37393D"}
                    height={21}
                    width={21}
                  />
                </li>
              ) : config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales ? (
                <></>
              ) : (
                <li className="item" onClick={() => navigateToCart()}>
                  <div className="item-text">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 29 29"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 3.69998H0.5V4.19998H1V3.69998ZM1 1V0.5H0.5V1H1ZM3.69998 3.69998L4.15174 3.4857L4.01622 3.19998H3.69998V3.69998ZM8.55994 13.9464L8.99786 14.1877L9.12142 13.9635L9.0117 13.7321L8.55994 13.9464ZM6.73745 17.2539L7.17163 17.502L7.17537 17.4952L6.73745 17.2539ZM25.2998 21.2498V21.7498H25.7998V21.2498H25.2998ZM25.2998 18.5499H25.7998V18.0499H25.2998V18.5499ZM9.32943 18.2124L8.84436 18.0911L8.82943 18.1508V18.2124H9.32943ZM9.36993 18.0504L8.93222 17.8087L8.90068 17.8658L8.88486 17.9291L9.36993 18.0504ZM10.5849 15.8499V15.3499H10.2898L10.1472 15.6082L10.5849 15.8499ZM23.0048 14.4594L22.567 14.2179L22.5664 14.219L23.0048 14.4594ZM27.8378 5.69796L28.2756 5.93947L28.2776 5.93575L27.8378 5.69796ZM27.8105 4.362L27.3807 4.61753V4.61754L27.8105 4.362ZM26.6498 3.69998L26.6509 3.19998H26.6498V3.69998ZM6.68345 3.69998L6.23094 3.91266L6.36598 4.19998H6.68345V3.69998ZM5.41446 1L5.86698 0.787319L5.73194 0.5H5.41446V1ZM1.5 3.69998V1H0.5V3.69998H1.5ZM3.69998 3.19998H1V4.19998H3.69998V3.19998ZM9.0117 13.7321L4.15174 3.4857L3.24822 3.91425L8.10818 14.1607L9.0117 13.7321ZM7.17537 17.4952L8.99786 14.1877L8.12202 13.7051L6.29953 17.0126L7.17537 17.4952ZM6.89996 18.5499C6.89996 18.1631 6.99938 17.8033 7.17158 17.5019L6.30333 17.0058C6.04353 17.4605 5.89996 17.9916 5.89996 18.5499H6.89996ZM9.09993 20.7498C7.89109 20.7498 6.89996 19.7587 6.89996 18.5499H5.89996C5.89996 20.311 7.3388 21.7498 9.09993 21.7498V20.7498ZM25.2998 20.7498H9.09993V21.7498H25.2998V20.7498ZM24.7998 18.5499V21.2498H25.7998V18.5499H24.7998ZM9.66693 19.0499H25.2998V18.0499H9.66693V19.0499ZM8.82943 18.2124C8.82943 18.6775 9.20179 19.0499 9.66693 19.0499V18.0499C9.75407 18.0499 9.82943 18.1252 9.82943 18.2124H8.82943ZM8.88486 17.9291L8.84436 18.0911L9.8145 18.3336L9.855 18.1716L8.88486 17.9291ZM10.1472 15.6082L8.93222 17.8087L9.80764 18.292L11.0226 16.0916L10.1472 15.6082ZM20.6423 15.3499H10.5849V16.3499H20.6423V15.3499ZM22.5664 14.219C22.1937 14.8986 21.4692 15.3499 20.6423 15.3499V16.3499C21.8405 16.3499 22.8979 15.6942 23.4432 14.6998L22.5664 14.219ZM27.4 5.45646L22.567 14.2179L23.4426 14.7009L28.2756 5.93947L27.4 5.45646ZM27.3807 4.61754C27.5343 4.87583 27.5409 5.19583 27.3979 5.46017L28.2776 5.93575C28.5879 5.36188 28.5737 4.66719 28.2403 4.10646L27.3807 4.61754ZM26.6486 4.19998C26.9491 4.20067 27.2272 4.35924 27.3807 4.61753L28.2403 4.10646C27.9069 3.54573 27.3033 3.20148 26.6509 3.19998L26.6486 4.19998ZM6.68345 4.19998H26.6498V3.19998H6.68345V4.19998ZM4.96195 1.21268L6.23094 3.91266L7.13597 3.4873L5.86698 0.787319L4.96195 1.21268ZM1 1.5H5.41446V0.5H1V1.5ZM6.91402 25.3C6.91402 24.0879 7.89491 23.1 9.1005 23.1V22.1C7.33611 22.1 5.91402 23.5422 5.91402 25.3H6.91402ZM9.1005 27.5C7.89491 27.5 6.91402 26.5121 6.91402 25.3H5.91402C5.91402 27.0579 7.33611 28.5 9.1005 28.5V27.5ZM11.3005 25.3C11.3005 26.5089 10.3093 27.5 9.1005 27.5V28.5C10.8616 28.5 12.3005 27.0612 12.3005 25.3H11.3005ZM9.1005 23.1C10.3093 23.1 11.3005 24.0912 11.3005 25.3H12.3005C12.3005 23.5389 10.8616 22.1 9.1005 22.1V23.1ZM22.6004 22.1C20.836 22.1 19.4139 23.5422 19.4139 25.3H20.4139C20.4139 24.0879 21.3948 23.1 22.6004 23.1V22.1ZM25.8004 25.3C25.8004 23.5389 24.3615 22.1 22.6004 22.1V23.1C23.8092 23.1 24.8004 24.0912 24.8004 25.3H25.8004ZM22.6004 28.5C24.3615 28.5 25.8004 27.0612 25.8004 25.3H24.8004C24.8004 26.5089 23.8092 27.5 22.6004 27.5V28.5ZM19.4139 25.3C19.4139 27.0579 20.836 28.5 22.6004 28.5V27.5C21.3948 27.5 20.4139 26.5121 20.4139 25.3H19.4139Z"
                        stroke={config?.webappcolor.fontmenu || "#37393D"}
                      />
                    </svg>
                    <p>Carrinho</p>
                  </div>
                </li>
              )}
              {hasIAPlugin && (
                <li
                  className="item"
                  onClick={() => navigate(`/${pluginspace_id}/chat-ia`)}
                >
                  <div className="item-text">
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 23 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.0136 22.27C1.8846 22.4232 1.86156 22.6619 1.78785 22.8647C1.98135 22.9097 2.17486 23.0044 2.36376 22.9998C4.30803 22.9413 6.03576 22.2745 7.62527 21.2067C7.77271 21.1076 7.99846 21.031 8.19658 21.022C9.23322 21.3509 10.339 21.5401 11.4908 21.5401C17.3236 21.5401 21.9954 16.9806 22 11.2768C22 5.57748 17.3328 1.00451 11.5046 1C5.67639 1 1 5.56397 1 11.2633C1 14.0837 2.14261 16.6247 3.99934 18.4764C4.03159 18.6026 4.04081 18.7377 4.01316 18.8459C3.66301 20.1614 2.87977 21.2382 2.01821 22.27H2.0136ZM12.8361 18.1295C12.4537 18.4899 11.993 18.6702 11.4539 18.6702C10.9149 18.6702 10.4541 18.4899 10.0717 18.1295C9.66169 17.742 9.43594 17.1924 9.45437 16.6337C9.4728 16.1246 9.6663 15.6876 10.0349 15.3272C10.4219 14.9487 10.8964 14.7595 11.4539 14.7595C12.0114 14.7595 12.4814 14.9487 12.873 15.3272C13.2416 15.6876 13.4351 16.1246 13.4535 16.6337C13.4719 17.1879 13.2462 17.7375 12.8361 18.125V18.1295ZM15.2734 10.1189C14.891 10.7452 14.3104 11.3038 13.5456 11.7859C13.283 11.9526 13.0849 12.1509 12.9651 12.3716C12.8453 12.5924 12.7808 12.8717 12.7808 13.2006V13.7683H10.4357C10.1316 13.7683 9.88284 13.525 9.88284 13.2276V12.7726C9.88284 12.1103 10.0487 11.5336 10.3712 11.0605C10.6845 10.601 11.1683 10.1595 11.8087 9.74948C12.1128 9.56025 12.3431 9.33498 12.4998 9.08718C12.6564 8.84389 12.7301 8.5961 12.7301 8.32577C12.7301 8.05545 12.638 7.8482 12.4445 7.70403C12.2372 7.54634 11.9193 7.46975 11.5046 7.46975C10.9702 7.46975 10.4357 7.60491 9.91049 7.86622C9.69855 7.97435 9.50044 8.096 9.31154 8.23116C8.71259 8.66368 7.8971 8.56906 7.4548 8.0149C6.97104 7.40667 7.0724 6.55515 7.67135 6.06406C8.01229 5.78473 8.41312 5.54144 8.85542 5.33419C9.71698 4.93321 10.6661 4.73047 11.6751 4.73047C12.9697 4.73047 13.9971 5.01431 14.7251 5.57748C15.4715 6.15417 15.8493 6.96965 15.8493 8.01039C15.8493 8.77631 15.6512 9.48366 15.2688 10.1189H15.2734Z"
                        stroke={config?.webappcolor.fontmenu || "#37393D"}
                        stroke-miterlimit="10"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <p>Atendimento</p>
                  </div>
                </li>
              )}

              {!isFood && (
                <li
                  className="item"
                  onClick={() => navigate(`/${pluginspace_id}/my_carts`)}
                >
                  <div className="item-text">
                    <svg
                      width="17"
                      height="15"
                      viewBox="0 0 16 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3 1.5C3 1.22386 3.22386 1 3.5 1H8.5C8.77614 1 9 1.22386 9 1.5V13.5L6 11L3 13.5V1.5Z"
                        stroke={config?.webappcolor.fontmenu || "#37393D"}
                        strokeWidth="1.2"
                        fill="none"
                      />
                      <path
                        d="M7 1.5C7 1.22386 7.22386 1 7.5 1H12.5C12.7761 1 13 1.22386 13 1.5V13.5L10 11L7 13.5"
                        stroke={config?.webappcolor.fontmenu || "#37393D"}
                        strokeWidth="1.2"
                        fill="none"
                      />
                    </svg>

                    <p>Meus Carrinhos</p>
                  </div>
                </li>
              )

              }
            </>
          )}
          {/* <li
						className="item"
						onClick={() => navigate(`/${pluginspace_id}/filter`)}
					>
						<p>Filtro</p>
					</li> */}

          {/* <li className="item" onClick={() => navigate(`/${pluginspace_id}/favorites`)}>
					<p>Favoritos</p>
				</li> */}

          {pluginspace.appLogin && !isSeller && (
            <>
              {localStorage.getItem("loginInfo") ? (
                <>
                  <li
                    className="item"
                    onClick={() => navigate(`/${pluginspace_id}/profile`)}
                  >
                    <p>Usuário</p>
                  </li>
                </>
              ) : (
                <>
                  <li
                    className="item"
                    onClick={() => navigate(`/${pluginspace_id}/auth`)}
                  >
                    <p>Acessar</p>
                  </li>
                </>
              )}

              {localStorage.getItem("loginInfo") && (
                <>
                  <li className="item" onClick={() => logout()}>
                    <p>Logout</p>
                  </li>
                </>
              )}
            </>
          )}
        </ul>
      </div>
      {openInfo && <ModalInfo isOpen={openInfo} setIsOpen={setOpenInfo} />}
    </>
  );
}
